import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import './UserOnboardingPage.css';
import { getResourceOptions } from "../../api/AdditionalServices.js";
import { Col, Row } from "antd";

const GetToKnowYou = ({ onboardingData, setOnboardingData }) => {
  const navigate = useNavigate();
  let plan = localStorage.getItem("free")

  const isFreePlan = plan === "One Week Free Trial";
  
  const [selectedNewsResources, setSelectedNewsResources] = useState(onboardingData.getToKnowYou?.newsResources || []);
  const [selectedQuickLinks, setSelectedQuickLinks] = useState(onboardingData.getToKnowYou?.quickLinks || []);
  const [selectedLeisure, setSelectedLeisure] = useState(onboardingData.getToKnowYou?.leisure || []);
  const [otherWebsites, setOtherWebsites] = useState(onboardingData.getToKnowYou?.otherWebsites || []);
  const [showPopup, setShowPopup] = useState(false);
  const [newWebsite, setNewWebsite] = useState({ name: "", url: "", type: "" });
  const popupRef = useRef(null);

  const [newsResources, setNewsResources] = useState([]);
  const [quickLinks, setQuickLinks] = useState([]);
  const [leisureOptions, setLeisureOptions] = useState([]);

  const fetchResourceOptions = async () => {
    try {
      const response = await getResourceOptions();
      const data = response.resources;
      setNewsResources(data.News);
      setQuickLinks(data.Game);
      setLeisureOptions(data.Leisure);
    } catch (error) {
      console.error('Error fetching resource options:', error);
      setNewsResources([]);
      setQuickLinks([]);
      setLeisureOptions([]);
    }
  };

  useEffect(() => {
    fetchResourceOptions();
  }, []);

  const handleSelectChange = (event, setSelected, selected, resources) => {  
    const { value } = event.target;
    const selectedResource = resources.find(resource => resource.name.toLowerCase() === value.toLowerCase());
    if (selectedResource && !selected.some(item => item.name.toLowerCase() === value.toLowerCase())) {
      setSelected([...selected, {
        name: selectedResource.name,
        url: selectedResource.url,
        imageUrl: selectedResource.imageUrl
      }]);
    }
  };
  
  const handleRemoveTag = (item, setSelected, selected) => {
    if (Array.isArray(selected)) {
      setSelected(selected.filter(currentItem => currentItem !== item));
    } else if (typeof setSelected === 'function') {
      setSelected(prevWebsites => prevWebsites.filter(website => website !== item));
    }
  };


  const handleNext = (event) => {
    event.preventDefault();
    setOnboardingData({
      ...onboardingData,
      getToKnowYou: {
        newsResources: selectedNewsResources,
        quickLinks: selectedQuickLinks,
        leisure: selectedLeisure,
        otherWebsites: otherWebsites,
      },
    });

    navigate('/onboarding/tell-us-more');

    // navigate('/onboarding/additional-services');
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowPopup(false);
    }
  };

  useEffect(() => {
    if (showPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopup]);

  const handlePopupSubmit = (event) => {
    event.preventDefault();
    setOtherWebsites(prevWebsites => {
      const updatedWebsites = [...prevWebsites, newWebsite];
      return updatedWebsites;
    });
    setNewWebsite({ name: "", url: "", type: "" });
    setShowPopup(false);
  };

  const handleBack = () => {
    navigate('/onboarding/contact-info');
  };

  return (
   <Row className="welcome-onboarding-row" style={{ background: "#fefcfe" }}>
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row gutter={24} className="welcome-onboarding-row-card-container">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Get to Know You</h1>
            <p>
              To better tailor the app to you, let us know your preferences in
              advance to streamline the setup experience.
            </p>
            <form onSubmit={handleNext}>
              <label htmlFor="newsResource">
                Would you like to add a preferred news resource?
              </label>
              <div className="multi-select-container">
                <div className="tags-container">
                  {selectedNewsResources.map((resource) => (
                    <span key={resource.name} className="tag">
                      {resource.name}
                      <button
                        type="button"
                        id="cross-tag"
                        onClick={() =>
                          handleRemoveTag(
                            resource,
                            setSelectedNewsResources,
                            selectedNewsResources
                          )
                        }
                      >
                        x
                      </button>
                    </span>
                  ))}
                </div>
                <select
                  onChange={(e) =>
                    handleSelectChange(
                      e,
                      setSelectedNewsResources,
                      selectedNewsResources,
                      newsResources
                    )
                  }
                  disabled={isFreePlan && selectedNewsResources.length >= 1}
                >
                  <option value="" disabled>
                    Select your preferred news source
                  </option>
                  {newsResources.map((resource) => (
                    <option
                      key={resource.name.toLowerCase()}
                      value={resource.name.toLowerCase()}
                    >
                      {resource.name}
                    </option>
                  ))}
                </select>
              </div>
              <label htmlFor="quickLink">
                Would you like to add a quick link to games you play online?
              </label>
              <div className="multi-select-container">
                <div className="tags-container">
                  {selectedQuickLinks.map((link) => (
                    <span key={link.name} className="tag">
                      {link.name}
                      <button
                        type="button"
                        id="cross-tag"
                        onClick={() =>
                          handleRemoveTag(
                            link,
                            setSelectedQuickLinks,
                            selectedQuickLinks
                          )
                        }
                      >
                        x
                      </button>
                    </span>
                  ))}
                </div>
                <select
                  onChange={(e) =>
                    handleSelectChange(
                      e,
                      setSelectedQuickLinks,
                      selectedQuickLinks,
                      quickLinks
                    )
                  }
                  disabled={isFreePlan && selectedQuickLinks.length >= 1}
                >
                  <option value="" disabled>
                    Select a quick link
                  </option>
                  {quickLinks.map((link) => (
                    <option
                      key={link.name.toLowerCase()}
                      value={link.name.toLowerCase()}
                    >
                      {link.name}
                    </option>
                  ))}
                </select>
              </div>
              <label htmlFor="leisure">Would you like to add a leisure?</label>
              <div className="multi-select-container">
                <div className="tags-container">
                  {selectedLeisure.map((link) => (
                    <span key={link.name} className="tag">
                      {link.name}
                      <button
                        type="button"
                        id="cross-tag"
                        onClick={() =>
                          handleRemoveTag(
                            link,
                            setSelectedLeisure,
                            selectedLeisure
                          )
                        }
                      >
                        x
                      </button>
                    </span>
                  ))}
                </div>
                <select
                  onChange={(e) =>
                    handleSelectChange(
                      e,
                      setSelectedLeisure,
                      selectedLeisure,
                      leisureOptions
                    )
                  }
                  disabled={isFreePlan && selectedLeisure.length >= 1}
                >
                  <option value="" disabled>
                    Select a leisure
                  </option>
                  {leisureOptions.map((link) => (
                    <option
                      key={link.name.toLowerCase()}
                      value={link.name.toLowerCase()}
                    >
                      {link.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* {!isFreePlan && (<Row style={componentStyles.rowStyle}>
                <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 24 }}>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    name="additionalPreferences"
                    label={<span style={componentStyles.labelStyle}>Additional Preferences</span>}
                  >
                    <div style={componentStyles.multiSelectContainer}>
                      <div className="tags-container">
                        {otherWebsites.map(site => (
                          <span key={site.name} className="tag">
                            {site.name}
                            <button type="button" style={componentStyles.crossTag} onClick={() => handleRemoveTag(site, setOtherWebsites, otherWebsites)}>x</button>
                          </span>
                        ))}
                      </div>
                      <button type="button" id="add-other-websites" onClick={() => setShowPopup(true)}>Add Website</button>
                    </div>
                  </Form.Item>
                </Col>
              </Row>)} */}
              {/* {showPopup && (
                <div style={componentStyles.popUp} ref={popupRef}>
                  <div style={componentStyles.popInner}>
                    <h2 style={componentStyles.popupTitle}>Add a new website</h2>
                    <Form >
                      <div style={componentStyles.formField}>
                        <label htmlFor="websiteName" style={componentStyles.formLabel}>
                          Name <i style={componentStyles.requiredInput}>*</i>
                        </label>
                        <input
                          id="websiteName"
                          type="text"
                          value={newWebsite.name}
                          onChange={(e) => setNewWebsite({ ...newWebsite, name: e.target.value })}
                          required
                          style={componentStyles.formInput}
                        />
                      </div>
                      <div style={componentStyles.formField}>
                        <label htmlFor="websiteUrl" style={componentStyles.formLabel}>
                          URL <i style={componentStyles.requiredInput}>*</i>
                        </label>
                        <input
                          id="websiteUrl"
                          type="text"
                          value={newWebsite.url}
                          onChange={(e) => setNewWebsite({ ...newWebsite, url: e.target.value })}
                          required
                          style={componentStyles.formInput}
                        />
                      </div>
                      <div style={componentStyles.formField}>
                        <label htmlFor="websiteType" style={componentStyles.formLabel}>
                          Type <i style={componentStyles.requiredInput}>*</i>
                        </label>
                        <select
                          name="type"
                          id="websiteType"
                          value={newWebsite.type}
                          onChange={(e) => setNewWebsite({ ...newWebsite, type: e.target.value })}
                          required
                          style={componentStyles.formInput}
                        >
                          <option value="" disabled>Select the type for URL</option>
                          <option value="news">News</option>
                          <option value="game">Game</option>
                          <option value="leisure">Lesiure</option>
                        </select>
                      </div>
                      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <Button type="submit" onClick={handlePopupSubmit} style={componentStyles.formButtonGetToKnowYou}>Add</Button>
                        <Button
                          type="button"
                          onClick={() => setShowPopup(false)}
                          style={componentStyles.cancelButton}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              )} */}
              <div className="button-container">
                <button type="button" className="back-button" onClick={handleBack}>
                  Back
                </button>
                <button type="submit" className="next-btn">
                  Next
                </button>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </Row>
  );
};

export default GetToKnowYou;